export const enum TabNames {
	DIGITAL_COLLECTIBLES = 'wallet-digital-collectibles',
	FAN_TOKENS = 'wallet-fan-tokens',
	MARKET = 'wallet-market'
}

export enum MarketplaceChipsFiltersType {
	AZ = 'A-Z',
	HighLow = 'High-Low',
	LowHigh = 'Low-High',
	ZA = 'Z-A'
}

export enum MarketplaceModalFilterTabs {
	Sports = 'sports',
	Teams = 'teams'
}
